import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  error: {
    color: theme.palette.secondary.dark,
  },
}));

export default useStyles;
